var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.0335 20.931c-0.5069 0-0.93867-0.17818-1.2953-0.53465-0.35644-0.35658-0.53465-0.78838-0.53465-1.2953v-14.029h-1.1327v-1.1327h4.531v-0.87136h6.7964v0.87136h4.531v1.1327h-1.1327v14.029c0 0.5214-0.17467 0.95682-0.52389 1.306-0.34922 0.34922-0.78465 0.52389-1.306 0.52389zm10.63-15.858h-11.327v14.029c0 0.20333 0.065325 0.3704 0.19596 0.50124 0.13083 0.1306 0.29791 0.19596 0.50124 0.19596h9.933c0.17444 0 0.33427-0.07261 0.47937-0.21782 0.14522-0.1451 0.21783-0.30493 0.21783-0.47937zm-8.1469 12.46h1.1327v-10.195h-1.1327zm3.8339 0h1.1327v-10.195h-1.1327z",
    clipPath: "url(#clipPath247)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })));
};
export default SvgTrash;